
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';
import { FishMapComponent } from './fish-map/fish-map.component';
import { AppConfigResoloverService } from './core/services/app-config-resolover.service';

const routes: Routes = [
  {
    path: '',
    component: FishMapComponent,
    resolve: { appConfig: AppConfigResoloverService }
  }
];

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forRoot(routes)
  ],
  exports: [
    RouterModule
  ],
  providers: []
})
export class AppRoutingModule { }
